import React, { Component } from 'react';


import { observable, computed } from 'mobx';
import { observer, inject } from 'mobx-react'
@inject("store")
@observer
class GeneralDetails extends Component {

	@observable error = false
	@observable errorText = "Please fill the name"

	componentDidMount() {
		this.props.store.step = 5
	}

	@computed get completed() {
		// const { doctor } = this.props.store
		return true
	}

	handleNext = () => {
		if (!this.completed) { this.error = true;return  }
		this.props.store.nextStep()
		this.props.history.push(`/listing/new/${this.props.store.step + 2}`)
	}

	handlePrev = () => {
		this.props.store.prevStep()
		this.props.history.push(`/listing/new/${this.props.store.step}`)
	}

	render() {
		const { doctor } = this.props.store
		return (
			<div>
				
				<h2 >6. Billing Policy</h2>

				<div className="special">
					<p>To help GPs comply with new accreditation standards set by the RACGP regarding specialist fees, please complete this section.</p>

					<p className="m-t-1">This section is optional. However, we believe that listing this information may help to improve your relationship with referrers and patients.</p>
				</div>

				<h4>Patient Billing <small>(Select all that apply)</small></h4>

				

				<div className="m-t-1">				
					<label>
						<input type="checkbox" name="children" checked={doctor.billingPolicy["All patients privately billed"]} onChange={e=>doctor.billingPolicy["All patients privately billed"] = !doctor.billingPolicy["All patients privately billed"]} />
						All patients privately billed
					</label>
				</div>

				<div>				
					<label>
						<input type="checkbox" name="children" value="Reduced gap for healthcare card" checked={doctor.billingPolicy["Reduced gap for healthcare card"]} onChange={e=>doctor.billingPolicy["Reduced gap for healthcare card"] = !doctor.billingPolicy["Reduced gap for healthcare card"]} />
						Reduced gap for healthcare card
					</label>
				</div>

				<div>				
					<label>
						<input type="checkbox" name="children" value="Reduced gap for pensioners" checked={doctor.billingPolicy["Reduced gap for pensioners"]} onChange={e=>doctor.billingPolicy["Reduced gap for pensioners"] = !doctor.billingPolicy["Reduced gap for pensioners"]} />
						Reduced gap for pensioners
					</label>
				</div>

				<div>				
					<label>
						<input type="checkbox" name="children" value="Reduced gap for children" checked={doctor.billingPolicy["Reduced gap for children"]} onChange={e=>doctor.billingPolicy["Reduced gap for children"] = !doctor.billingPolicy["Reduced gap for children"]} />
						Reduced gap for children
					</label>
				</div>

				<div>				
					<label>
						<input type="checkbox" name="children" value="Bulk bill healthcare card" checked={doctor.billingPolicy["Bulk bill healthcare card"]} onChange={e=>doctor.billingPolicy["Bulk bill healthcare card"] = !doctor.billingPolicy["Bulk bill healthcare card"]} />
						Bulk bill healthcare card
					</label>
				</div>

				<div>				
					<label>
						<input type="checkbox" name="children" value="Bulk bill pensioners" checked={doctor.billingPolicy["Bulk bill pensioners"]} onChange={e=>doctor.billingPolicy["Bulk bill pensioners"] = !doctor.billingPolicy["Bulk bill pensioners"]} />
						Bulk bill pensioners
					</label>
				</div>

				<div>				
					<label>
						<input type="checkbox" name="children" value="Bulk bill children" checked={doctor.billingPolicy["Bulk bill children"]} onChange={e=>doctor.billingPolicy["Bulk bill children"] = !doctor.billingPolicy["Bulk bill children"]} />
						Bulk bill children
					</label>
				</div>

				<div>				
					<label>
						<input type="checkbox" name="children" value="All patients bulk billed" checked={doctor.billingPolicy["All patients bulk billed"]} onChange={e=>doctor.billingPolicy["All patients bulk billed"] = !doctor.billingPolicy["All patients bulk billed"]} />
						All patients bulk billed
					</label>
				</div>

				<div>				
					<label>
						<input type="checkbox" name="children" value="Prefer not to say" checked={doctor.billingPolicy["Prefer not to say"]} onChange={e=>doctor.billingPolicy["Prefer not to say"] = !doctor.billingPolicy["Prefer not to say"]} />
						Prefer not to say
					</label>
				</div>


				<h4>Standard Initial Consultation Fee:</h4>

				
				
				<input
					type="text"
					placeholder="$..."
					className={`input small `}
					value={doctor.consultationFee}
					onChange={e => doctor.consultationFee = e.target.value} />
				
				
				

				<div className="m-t-1">
					<div
						onClick={this.handlePrev}	
						className={`btn base m-r-1`}><i className="fa fa-fw fa-arrow-left"></i> Previous</div>	
					<div
						onClick={this.handleNext}	
						className={`btn ${!this.completed && 'disabled'}`}><i className="fa fa-fw fa-arrow-right"></i> Next</div>
				</div>
				
			</div>
		);
	}
}

export default GeneralDetails;


// WEBPACK FOOTER //
// ./src/Containers/Listing/6.BillingPolicy.js